import router from '@/router'

export function is_weixin() {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}

export function focusInput(item) {
  if (item.$el) {
    const input = item.$el.getElementsByTagName('input')[0]
    setTimeout(() => {
      input.dispatchEvent(new Event('focus'))
      input.focus()
    }, 0)

  } else {
    item.focus()
  }
}


export function is_app(name) {
  if (router.mode === "hash") {
    router.push({
      name
    })
  } else {
    window.location.href = router.options.routes.find(t => t.name === name).path
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js